import { Col2 } from "react-native-col";
import {
  CheckboxInput,
  Col1,
  NumberInput,
  PickerInput,
  Row,
  TextLabel,
} from "../lib";
import { formatDuration } from "../services";
import { createStyles, sizes } from "../theme";

const SHOTS_OPTIONS = [1, 2, 3, 4, 5].map((value) => ({
  label: `${value} shot${value > 1 ? "s" : ""}`,
  value,
}));

type Props = {
  active?: boolean;
  amount: number | null;
  discountedAmount: number | null;
  duration: number;
  onChange: (duration: string, value: boolean) => void;
  onChangeAmount: (duration: string, value: number | null) => void;
  onChangeShots: (duration: string, value: number | null) => void;
  shots: number;
};

export function RateInput({
  active = false,
  amount,
  discountedAmount,
  duration,
  onChange,
  onChangeAmount,
  onChangeShots,
  shots,
}: Props) {
  return (
    <Row.LRT style={$.container} mb="4">
      <Col1 mt="4">
        <CheckboxInput
          label={formatDuration(duration)}
          name={`${duration}`}
          value={active}
          onChange={onChange}
        />
      </Col1>
      <Col2>
        <PickerInput
          disabled={!active}
          name={`${duration}`}
          value={shots}
          onChange={onChangeShots}
          options={SHOTS_OPTIONS}
        />
      </Col2>
      <Col2>
        <NumberInput
          disabled={!active}
          name={`${duration}`}
          value={amount}
          onChange={onChangeAmount}
          placeholder="Price"
        />
        {!!discountedAmount && !!amount && discountedAmount < amount && (
          <TextLabel ml="4" mt="1">
            Premium price: {discountedAmount}
          </TextLabel>
        )}
      </Col2>
    </Row.LRT>
  );
}

const $ = createStyles({
  container: {
    gap: sizes["2"],
  },
});
